import { render, staticRenderFns } from "./GiftUpdateImage.vue?vue&type=template&id=81b7d000&scoped=true&"
import script from "./GiftUpdateImage.vue?vue&type=script&lang=js&"
export * from "./GiftUpdateImage.vue?vue&type=script&lang=js&"
import style0 from "./GiftUpdateImage.vue?vue&type=style&index=0&id=81b7d000&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b7d000",
  null
  
)

export default component.exports